<template>
    <v-card class="stepper-content border-bottom" flat>
        <v-card-title class="d-flex mt-4">
            {{schema.title}}
            <div class="infobox-container" >
                <div v-if="schema.infoText" class="infobox-container__icon"
                     @mouseover="showInfobox('infoBox_', 1, schema.infoText)"
                     @mouseleave="hideInfoBox('infoBox_', 1, schema.infoText)">
                    <v-icon color="primary">mdi-information-outline</v-icon>
                </div>
                <InfoboxTooltip ref="infoBox_1"/>
            </div>
        </v-card-title>
        <v-card-subtitle>{{schema.description}}</v-card-subtitle>
        <v-card-text class="mt-4">
            <div v-for="field in schema.fields" :key="field.name" >
                <h5>{{field.name}}</h5>
                <v-row style="margin-top:20px;" class="border-bottom">
                    <v-col class="textWithInfo"><span class="text-gray font-s font-weight-black">Fragen</span>
                      <div v-if="field.infoText" class="infobox-container" >
                        <div class="infobox-container__icon"
                            @mouseover="showInfobox('infoBoxIter_', schema.fields.indexOf(field), field.infoText)"
                            @mouseleave="hideInfoBox('infoBoxIter_', schema.fields.indexOf(field), field.infoText)">
                          <v-icon color="primary">mdi-information-outline</v-icon>
                        </div>
                        <InfoboxTooltip :ref="'infoBoxIter_'+ schema.fields.indexOf(field)"/>
                      </div>
                      
                    </v-col>
                    <v-col class="" v-if="fieldIsText(field)">
                        <span class="text-gray font-s font-weight-black">Hier können Sie Notizen machen</span>
                    </v-col>
                    <v-col class="" v-if="fieldIsMatrix(field)" align-self="center">
                        <div v-for="value in matrixValues" :key="value" :style="'display: inline-block; width: '+(100/matrixValues.length)+'%'">
                          <span class="text-gray font-s font-weight-black">{{value}}</span>
                            <div v-if="value == 'Vollständig erledigt'"
                                 class="infobox-container textWithInfo infobox-container__right">
                            <div  class="infobox-container__icon " 
                                @mouseover="showInfobox('infoBox_', 2, infoTextForMatrixValue)"
                                @mouseleave="hideInfoBox('infoBox_', 2, infoTextForMatrixValue)">
                              <v-icon color="primary">mdi-information-outline</v-icon>
                            </div>
                            <InfoboxTooltip ref="infoBox_2"/>
                          </div>
                        </div>
                    </v-col>
                </v-row>
              <v-row v-for="option in field.options" :key="option.question">
                
                    <v-col class="mb-4">{{option.question}}</v-col>
                    <v-col class="mb-8" v-if="fieldIsText(field)">
                        <v-textarea
                            name="input-7-1"
                            filled
                            auto-grow
                            v-model="option.answer"
                        ></v-textarea>

                    </v-col>
                    <v-col class="mb-8" v-if="fieldIsMatrix(field)">
                        <v-radio-group
                        row
                        v-model="option.answer"
                        class="flex-center"
                        >
                        <div v-for="(val, index) in matrixValues" :key="val" :style="'display: inline-block; width: '+(100/matrixValues.length)+'%'">
                            <v-radio
                                :key="index"
                                :value="index"
                            ></v-radio>
                        </div>
                        </v-radio-group>
                        
                        
                    </v-col>
                </v-row>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import checklistGenerator from "@/components/checklistGenerator.js"
import InfoboxTooltip from "@/components/common/InfoboxTooltip.vue"
  export default {
    components: {
      InfoboxTooltip
    },
    props:{
        schema: Object
    },
    data () {
      return {
        matrixValues: [],
        infoTextForMatrixValue: "Falls die Aufgabe <b>nicht auf Ihr Unternehmen zuzuordnen</b> ist, kreuzen Sie diese" +
                                " mit" +
                                " „<b>Vollständig erledigt</b>“ an. Der Arbeitsstand kann jederzeit abgerufen werden, um zu sehen, welche" +
                                " Punkte noch offen sind.",
      }
    },
    mounted(){
      this.matrixValues = checklistGenerator.matrixValues;
      // checklistGenerator.getMatrixValues();
      // checklistGenerator.getInfoTextForMatrixValue();
      // checklistGenerator.getInfoTextForTrafficLight();
    },
    methods:{
        fieldIsText(field){
            return field.type == 'text';
        },
        fieldIsMatrix(field){
            return field.type == 'matrix';
        },
        showInfobox(refPrefix, idx, infoText) {
          let selectedComponent = this.$refs[refPrefix + idx];
          if (Array.isArray(selectedComponent)) {
            return selectedComponent[0].open(infoText);
          } else {
            return selectedComponent.open(infoText);
          }
        },
        hideInfoBox(refPrefix, idx, infoText) {
          let selectedComponent = this.$refs[refPrefix + idx];

          if (Array.isArray(selectedComponent)) {
            return selectedComponent[0].close(infoText);
          } else {
            return selectedComponent.close(infoText);
          }
        },
    }
  }
</script>
<style scoped>
.textWithInfo{
  display: inline-flex;
}
.infobox-container__right .infobox-content {
  right: 0;
}
:deep .v-input--radio-group__input div {
  margin: 0 auto;
}
:deep .col.align-self-center div {
  display: inline-flex !important;
  justify-content: center;
}
:deep .v-input--selection-controls__ripple {
  top: -5px;
  left: -5px;
}
</style>